import styled from 'styled-components';
import { Column } from '@prisjakt/ui/list/variants';
import { media } from 'src/components/base';
import { Button } from 'src/components/button';
import { PanelHeader } from '@prisjakt/ui/panel';

export const FlexColumn = styled(Column)`
  flex: 0 1 auto;
`;

export const StyledPanelHeader = styled(PanelHeader)`
  ${media.smallOnly`
    flex-direction: column;
  `}
`;

export const CallToActionButton = styled(Button).attrs({
  color: 'primary',
  variant: 'outlined',
})`
  color: ${p => p.theme.text.callToAction};
`;
